import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "p-2 w-full" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "text-lg font-semibold" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { key: 0 }

import { Community } from '@/models/Search';
import { PropType, ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  cluster: {
    type: Object as PropType<Community>,
    required: true,
  },
  clusterColor: {
    type: String,
    default: '#000000',
  },
  nodeType: {
    type: String,
    default: 'publications',
  },
},
  emits: ['select', 'unselect'],
  setup(__props, { emit }) {

const props = __props





let selected = ref(false);
let classes: Ref<string[]> = ref([]);

const switchSelected = () => {
  if (selected.value) {
    classes.value = [];
    emit('unselect', parseInt(props.cluster.id));
  } else {
    classes.value = ['bg-primary-lightest'];
    emit('select', parseInt(props.cluster.id));
  }
  selected.value = !selected.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["border border-gray-300 rounded-l cursor-pointer", _unref(classes)]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (switchSelected()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex-shrink-0 w-4 border-r border-gray-300 rounded-l",
        style: _normalizeStyle({ backgroundColor: __props.clusterColor })
      }, null, 4),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(__props.cluster.displayName), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.cluster.properties.size + ' ' + __props.nodeType), 1)
        ]),
        (__props.cluster.properties.keywords)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.cluster.properties.keywords.map((keywordTuple) => keywordTuple[0]).join(', ')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})